<h2 mat-dialog-title class="av-section-title">{{ 'backoffice.organizations.suspend_dialog.title' | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ data.organizationName }}</p>

  <div class="av-banner p-3 d-flex align-items-start gap-2">
    <mat-icon aria-hidden="true">warning</mat-icon>
    <span>
      {{ 'backoffice.organizations.overview.lifecycle.suspend_consequence' | translate }}
    </span>
  </div>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="suspend-reason">
      <span class="av-meta">
        {{ 'backoffice.organizations.suspend_dialog.reason_label' | translate }}
      </span>
      <textarea
        id="suspend-reason"
        class="av-field"
        rows="3"
        maxlength="255"
        formControlName="reason"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-danger"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
  >
    {{ 'backoffice.organizations.suspend_dialog.confirm' | translate }}
  </button>
</mat-dialog-actions>
